import { createApp } from 'vue'
import './style.css'
import App from './App.vue'
import VueGtag from "vue-gtag";
import { Quasar } from 'quasar'
import router from './router'


// Import icon libraries
// import '@quasar/extras/roboto-font/roboto-font.css'
import '@quasar/extras/material-icons/material-icons.css'
// import '@quasar/extras/material-icons-outlined/material-icons-outlined.css'
// import '@quasar/extras/material-icons-round/material-icons-round.css'
// import '@quasar/extras/material-icons-sharp/material-icons-sharp.css'

// A few examples for animations from Animate.css:
// import @quasar/extras/animate/fadeIn.css
// import @quasar/extras/animate/fadeOut.css

// Import Quasar css
import 'quasar/src/css/index.sass'

//used for custom SVG icons
import svgDirective from './directives/svg';


const myApp = createApp(App)


myApp.directive('svg', svgDirective);

myApp.use(Quasar, {
  plugins: {}, // import Quasar plugins and add here
})
myApp
  .use(router)
  // .use(VueGtag, {
  //   config: { id: "G-GGFNTR0EV9" },
  // }, router)
  .mount("#app");
